import React from 'react';

import {
  useCheckMemberSupplier,
  useCheckIsSuperAdmin,
  useCheckIsSuperMember,
} from 'hooks';

const useCheckIsShowForSupplierMember = () => {
  const isMemberSupplierUser = useCheckMemberSupplier();
  const isSuperAdmin = useCheckIsSuperAdmin();
  const isSuperMember = useCheckIsSuperMember();

  if (isSuperMember || isSuperAdmin) {
    return true;
  }

  if (isMemberSupplierUser) {
    return false;
  }

  return true;
};

const IsShowForSupplierMemberWrap = ({ children, ...restProps }) => {
  const isShow = useCheckIsShowForSupplierMember();

  const renderChildren = () => {
    if (!children) return null;

    return React.Children.map(children, (child) => {
      return child ? React.cloneElement(child, restProps) : null;
    });
  };

  return <> {isShow ? renderChildren() : null}</>;
};

export { useCheckIsShowForSupplierMember, IsShowForSupplierMemberWrap };
